<template>
    <div class="module module--space-default">
        <div class="workout-preview">
            <div class="container container--nooverflow">
                <div class="workout-preview__inner">
                    <div class="workout-preview__top">
                        <h3 class="workout-preview__title h5">{{title}}</h3>

                        <router-link v-if="contentId" :to="{name: 'Workouts', params: {filter: contentId}}">
                            <div class="more-link">
                                <span v-translate>more</span>
                                <Icon name="arrow-right"></Icon>
                            </div>
                        </router-link>
                    </div>
                    <swiper :options="sliderOptions" class="workout-preview__slider">
                        <swiper-slide v-for="workout in tenWorkouts" :key="workout.id" class="workout-preview__slide">
                            <WorkoutCard :carddata="workout" class="workout-card--full"></WorkoutCard>
                        </swiper-slide>
                        <swiper-slide v-if="workouts.length > 10 && contentId">
                             <router-link :to="{name: 'Workouts', params: {filter: contentId}}">
                                <div class="workout-preview__more">
                                    <div class="workout-preview__more__inner">
                                        <img alt="PUMATRAC" src="../assets/trac-logo-light.svg" />
                                        <div class="h5" v-translate>find_more</div>
                                        <Icon name="arrow-right"></Icon>

                                    </div>
                                </div>
                            </router-link>
                        </swiper-slide>   
                    </swiper>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import WorkoutCard from "@/components/WorkoutCard.vue"


export default {
    components: {
        WorkoutCard
    },
    props: {
        title: {
            type: String
        },
        workouts: {
            type: Array,
            required: true
        },
        contentId: {
            type: String,
            default: '',
        }
    },
    data () {
        return {
             sliderOptions: {
                speed: 400,
                slidesPerView: 1,
                spaceBetween: 12,
                breakpoints: {
                    760: {
                        slidesPerView: 2
                    },
                    980: {
                        slidesPerView: 3
                    },
                    1440: {
                        slidesPerView: 4
                    },
                }
            },
        }
    },
    computed: {
        filteredWorkouts() {
            // return this.workouts.filter(workout => {return workout.kind === 'Workout'})
            return this.workouts
        },
        tenWorkouts() {
            return this.filteredWorkouts.slice(0, 10)
        }
    }
}
</script>

<style lang="scss" scoped>
.workout-preview {
    overflow: hidden;

    &__top {
        margin-bottom: 40px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        @include mq($until: tablet) {
            margin-bottom: 20px;
        }
    }

    &__slider {
        overflow: visible;
    }

    &__more {
        position: relative;
        width: 100%;
        padding-bottom: 125%;
        background: black;
        color: white;
        border-radius: 4px;

        &__inner {
            @include fillout;
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-direction: column;
            padding: 20px;
        }
    }
}
</style>